import * as React from 'react';
import {Item, Category} from '../data';
import Masonry = require('masonry-layout');
import {Item as ItemComponent} from './Item';
import $ = require('jquery');
import l10n = require('diy/util/l10n');

interface ContentProps {
    columnsNo: number;
    categories: Category[];
    activeCategory?: Category;
    onScroll?: (category: Category) => any;
}

interface ContentState {
    scrollTop: number;
}

interface BoxData {
    category: Category;
    top: number;
    height: number;
}

const COLUMN_WIDTH = 264;
const PADDING = 24;

export const computeContentWidth = (columnsNo: number) => {
    return columnsNo * (COLUMN_WIDTH + PADDING) + PADDING;
};

export class Content extends React.Component<ContentProps, ContentState> {
    private itemContainers = new Map<Category, HTMLElement>();
    private categoryElements = new Map<Category, HTMLElement>();
    private masonries = new Map<Category, Masonry>();
    private contentEl: HTMLElement;
    private containerBoxData: BoxData[] = [];

    constructor(props: ContentProps, context?: any) {
        super(props, context);

        this.state = {
            scrollTop: 0
        };
    }

    render() {
        return (
            <div style={this.getRootStyles()} className="content"
                ref={ref => this.contentEl = ref}
            >{
                this.props.categories.map(category => this.renderCategory(category))
            }</div>
        );
    }

    componentDidMount() {
        for (let category of this.props.categories) {
            let masonry = new Masonry(this.itemContainers.get(category), {
                columnWidth: COLUMN_WIDTH + PADDING
            });
            this.masonries.set(category, masonry);
        }

        this.cacheContainerBoxes();

        this.contentEl.addEventListener('scroll', this.handleScroll);
    }

    componentDidUpdate(prevProps: ContentProps, prevState: ContentState) {
        let activeCategory = this.props.activeCategory;
        let prevCategory = this.getCategoryByScrollTop(prevState.scrollTop);
        if (activeCategory && activeCategory !== prevCategory) {
            let el = this.categoryElements.get(activeCategory);
            if (!el) {
                throw new Error(`Invalid category ${activeCategory.id}`);
            }

            this.contentEl.removeEventListener('scroll', this.handleScroll);
            $(this.contentEl).scrollTo(el, 400, {
                axis: 'y',
                offset: -PADDING,
                onAfter: () => {
                    this.contentEl.addEventListener('scroll', this.handleScroll);
                }
            });
        }

        if (this.props.columnsNo !== prevProps.columnsNo) {
            this.masonries.forEach(masonry => {
                masonry.layout();
            });

            this.cacheContainerBoxes();
        }
    }

    private getContentWidth() {
        return this.props.columnsNo * (COLUMN_WIDTH + PADDING) + PADDING;
    }

    private cacheContainerBoxes() {
        this.containerBoxData = Array.from(this.categoryElements)
            .map(([category, element]) => {
                return {
                    category,
                    top: element.offsetTop,
                    height: element.offsetHeight
                };
            });
    }

    private handleScroll = (e: UIEvent) => {
        let scrollTop = this.contentEl.scrollTop;
        let category = this.getCategoryByScrollTop(scrollTop);
        // Hack: set state without re-render
        (this.state as ContentState).scrollTop = scrollTop;
        this.props.onScroll(category);
    };

    private getCategoryByScrollTop(scrollTop: number) {
        return this.containerBoxData.find(boxData => {
            return scrollTop < boxData.top - PADDING + boxData.height;
        }).category;
    }

    private renderGuidanceLink() {
        let helpArticleId = "d854053.dita";
        let onClick = () => { cms.help.GuidedAssistant.getInstance()._openHelpTopic(helpArticleId); };
        let text = l10n.getString('section.selector.guidanceLink');
        return (
            <a className="guidance" onTouchTap={onClick}>
                {text}
            </a>
        );
    }
    private renderCategory(category: Category) {
        return (
            <div data-test-id={`category-${category.id}`}
                key={category.id}
                ref={ref => this.categoryElements.set(category, ref)}
            >
                <div className="category-header">
                    <div className="category-title">{category.label}</div>
                    <div className="category-desc">{category.description}
                        {this.renderGuidanceLink()}
                    </div>
                </div>
                <div style={this.getItemContainerStyles()}
                    ref={ref => this.itemContainers.set(category, ref)}
                >
                    {category.items.map(item => this.renderItem(item, category))}
                </div>
            </div>
        );
    }

    private renderItem(item: Item, category: Category) {
        let thumbWidth = COLUMN_WIDTH;
        let thumbHeight = Math.floor(COLUMN_WIDTH * (item.thumbHeight / item.thumbWidth));

        return (
            <div key={category.id + "/" + item.base + "/" + item.variant}
                style={this.getItemWrapperStyles()}
            >
                <ItemComponent item={item} width={thumbWidth} height={thumbHeight} />
            </div>
        );
    }

    private getRootStyles() {
        return {
            boxSizing: "border-box",
            WebkitBoxSizing: "border-box",
            paddingTop: PADDING + "px",
            paddingLeft: PADDING + "px",
            position: "relative"
        };
    }

    private getItemContainerStyles() {
        return {
            width: this.getContentWidth() - PADDING + "px"
        };
    }

    private getItemWrapperStyles() {
        return {
            width: COLUMN_WIDTH + PADDING + "px",
            boxSizing: "border-box",
            WebKitBoxSizing: "border-box",
            paddingRight: PADDING + 'px',
            paddingBottom: PADDING + "px"
        };
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/site-admin/section-selector/components/Content.tsx
 **/